import { useBi } from "../../lib/customer";
import { Reveal } from "../Common";
import { Counter } from "./Kit";

export function Glance({ g }) {
  const b = useBi();
  if (!g) return null;
  const items = [
    ["properties", g.properties, b("Properties listed", "عقار معروض")],
    ["projects", g.active_projects, b("Active projects", "مشروع قائم")],
    ["cities", g.cities, b("Cities covered", "مدينة نغطيها")],
    ["units", g.flagship_units, b("Units in Al Hamra", "وحدة في مشروع الحمراء")],
  ];
  return (
    <section data-testid="home-glance" className="on-media relative overflow-hidden bg-brand py-20">
      <div className="mashrabiya pointer-events-none absolute inset-0 opacity-[0.07]" aria-hidden="true" />
      <div className="container-lux relative">
        <Reveal className="mb-12 flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="eyebrow mb-4">{b("Company at a glance", "الشركة في لمحة")}</p>
            <h2 className="h-display text-3xl sm:text-4xl">{b("Our portfolio, today", "محفظتنا اليوم")}</h2>
          </div>
          <p data-testid="glance-live-label" className="inline-flex items-center gap-2 text-xs uppercase tracking-wider text-fg/60">
            <span className="h-2 w-2 animate-pulse rounded-full bg-cta" />{b("Live figures from our listings", "أرقام مباشرة من قوائمنا")}
          </p>
        </Reveal>
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-sm border border-fg/10 bg-fg/10 lg:grid-cols-4">
          {items.map(([k, v, label], i) => (
            <Reveal key={k} delay={i * 0.08} className="bg-brand p-6 md:p-10">
              <p className="font-display text-5xl text-cta md:text-6xl"><Counter to={v} testid={`glance-${k}`} /></p>
              <p className="mt-3 text-sm text-fg/70">{label}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
